import { Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useCommonStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            marginTop: 0,
            [theme.breakpoints.only('desktop')]: {
                paddingTop: '48px',
                paddingBottom: '48px',
                paddingLeft: '128px',
                paddingRight: '128px',
            },
            [theme.breakpoints.only('tablet')]: {
                paddingTop: '48px',
                paddingBottom: '48px',
                paddingLeft: '52px',
                paddingRight: '52px',
            },
            [theme.breakpoints.down('tablet')]: {
                paddingTop: '40px',
                paddingBottom: '40px',
                paddingLeft: '16px',
                paddingRight: '16px',
            },
        },
        imgContainer: {
            marginTop: 0,
            [theme.breakpoints.only('desktop')]: {
                paddingTop: '180px',
                paddingBottom: '180px',
                paddingLeft: '128px',
                paddingRight: '128px',
            },
            [theme.breakpoints.only('tablet')]: {
                paddingTop: '180px',
                paddingBottom: '180px',
                paddingLeft: '52px',
                paddingRight: '52px',
            },
            [theme.breakpoints.down('tablet')]: {
                paddingTop: '80px',
                paddingBottom: '80px',
                paddingLeft: '16px',
                paddingRight: '16px',
            },
        },
        content: {
            marginTop: 0,
            [theme.breakpoints.only('desktop')]: {
                paddingLeft: '128px',
                paddingRight: '128px',
            },
            [theme.breakpoints.only('tablet')]: {
                paddingLeft: '52px',
                paddingRight: '52px',
            },
            [theme.breakpoints.down('tablet')]: {
                paddingLeft: '16px',
                paddingRight: '16px',
            },
        },
        footerContainer: {
            marginTop: 0,
            [theme.breakpoints.only('desktop')]: {
                paddingTop: '80px',
                paddingBottom: '80px',
                paddingLeft: '128px',
                paddingRight: '128px',
            },
            [theme.breakpoints.only('tablet')]: {
                paddingTop: '80px',
                paddingBottom: '80px',
                paddingLeft: '32px',
                paddingRight: '32px',
            },
            [theme.breakpoints.down('tablet')]: {
                paddingTop: '40px',
                paddingBottom: '40px',
                paddingLeft: '16px',
                paddingRight: '16px',
            },
        },
        breadCrumbContainer: {
            [theme.breakpoints.only('desktop')]: {
                paddingTop: '24px',
                paddingBottom: '24px',
                paddingLeft: '128px',
                paddingRight: '128px',
            },
            [theme.breakpoints.only('tablet')]: {
                paddingTop: '24px',
                paddingBottom: '24px',
                paddingLeft: '52px',
                paddingRight: '52px',
            },
            [theme.breakpoints.down('tablet')]: {
                paddingTop: '16px',
                paddingBottom: '16px',
                paddingLeft: '16px',
                paddingRight: '16px',
            },
        },
    })
);
export default useCommonStyles;
